import queryString from 'query-string'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom-v5'
import { type Category } from './CategoryTabs'

const isValidateTab = (tab: string, availableCategoryTabs: Category[]): boolean => {
  return availableCategoryTabs.some(availableTab => tab === availableTab.value)
}
const getValidCategoryTab = (tabFromQuery: string, availableCategoryTabs: Category[]): string => {
  const fallbackTab = availableCategoryTabs?.[0]
  if (tabFromQuery) {
    if (isValidateTab(tabFromQuery, availableCategoryTabs)) {
      return tabFromQuery
    }
  }
  return fallbackTab?.value || ''
}

export const useCategoryTabs = (availableCategoryTabs: Category[]) => {
  const { search } = useLocation()
  const queryParams = queryString.parse(search)
  const tabFromQueryParams = queryParams.tab as string
  const [category, setCategory] = useState(tabFromQueryParams)

  useEffect(() => {
    setCategory(getValidCategoryTab(tabFromQueryParams, availableCategoryTabs))
  }, [availableCategoryTabs, tabFromQueryParams])

  return {
    category,
    setCategory,
  }
}
